class EmployeeCardListController {

  constructor() {
    "ngInject";
  }

}

export default EmployeeCardListController;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/components/employee-card-list/employee-card-list.controller.js